import {buildArgsAndVarDefs} from "@/utils/buildArgsAndVarDefs";

export function parseFragmentHeader(fragmentSource) {
    const m = /fragment\s+(\w+)\s+on\s+(\w+)/i.exec(fragmentSource);
    if (!m) throw new Error("Invalid fragment: expected 'fragment <Name> on <Type> { ... }'");
    return {fragmentName: m[1], typeName: m[2]};
}

/**
 * Always auto-builds args/varDefs from variables + typeMap.
 * No manual args/varDefs anymore.
 */

export function buildMutation({fragment, mutationName, field, variables = {}, typeMap = {},} = {}) {
    if (!field) throw new Error("buildMutation: 'field' is required");

    const {argsStr, varDefsStr} = buildArgsAndVarDefs(variables, typeMap);

    // === with fragment ===
    if (fragment) {
        const {fragmentName} = parseFragmentHeader(fragment);

        const query = `
          ${fragment}
          mutation ${mutationName || ''}${varDefsStr} {
            ${field}${argsStr} {
              ...${fragmentName}
            }
          }
        `;

        return {query};
    }

    // === no fragment and for Boolean type ===
    const query = `
        mutation ${mutationName || ''}${varDefsStr} {
          ${field}${argsStr}
        }
     `;

    return {query};
}


export default {buildMutation, parseFragmentHeader};
